import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { ClothingOption } from '../../../models/clothing.model';

interface ClothingDepartmentMarkerOption extends ClothingOption {
  departmentMarkerCode?: string;
}

@Component({
  selector: 'app-clothing-admin-department-marker',
  templateUrl: './clothing-admin-department-marker.component.html',
  styleUrls: ['./clothing-admin-department-marker.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ClothingAdminDepartmentMarkerComponent {
  @Input() departments: ClothingDepartmentMarkerOption[] = [];
  @Input() markerOptions: ClothingOption[] = [];
  @Input() hideHeader = false;
  @Input() selectedDepartmentId = '';
  @Input() selectedMarkerCode = '';
  @Input() draftMarkerCode = '';
  @Input() isSaving = false;
  @Output() selectDepartment = new EventEmitter<string>();
  @Output() selectMarker = new EventEmitter<string>();
  @Output() updateDraftMarker = new EventEmitter<string>();
  @Output() saveMarker = new EventEmitter<void>();

  submitDepartment(departmentId: string) {
    this.selectDepartment.emit(departmentId);
  }

  submitMarker(markerCode: string) {
    this.selectMarker.emit(markerCode);
  }

  submitDraftMarker(markerCode: string) {
    this.updateDraftMarker.emit(markerCode);
  }

  submitSave() {
    this.saveMarker.emit();
  }

  trackByOption(index: number, option: ClothingOption): string {
    return option.id;
  }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/admin/clothing/clothing-admin-department-marker.component.ts